import { QuestionWithRelations } from "../../../../../api/src/types";
import ReadOnlyDropdown from "./ReadOnlyDropdown";
import ReadOnlyRadioCheckbox from "./ReadOnlyRadioCheckbox";
import ReadOnlyTextBoxArea from "./ReadOnlyTextBoxArea";

interface ReadOnlyQuestionProps {
  question: QuestionWithRelations;
}

const ReadOnlyQuestion: React.FC<ReadOnlyQuestionProps> = ({ question }) => {
  const missingAnswerMessage = "The client has not answered this question.";

  switch (question.questionType) {
    case "CHECKBOX":
    case "RADIO":
      return (
        <ReadOnlyRadioCheckbox
          question={question}
          missingAnswerMessage={missingAnswerMessage}
        />
      );
    case "DROPDOWN":
      return (
        <ReadOnlyDropdown
          question={question}
          missingAnswerMessage={missingAnswerMessage}
        />
      );
    case "TEXT_BOX":
    case "TEXT_AREA":
      return (
        <ReadOnlyTextBoxArea
          question={question}
          missingAnswerMessage={missingAnswerMessage}
        />
      );
  }
};

export default ReadOnlyQuestion;
